import * as settingsConstants from "./constants";
import locale from "../../../locale";

export const themeColorTitles = {
    [settingsConstants.THEME_LIGHT]: 'Светлая',
    [settingsConstants.THEME_DARK]: 'Темная',
};

export const themeColorsOptions = [
    {
        title: locale('email.accentColor'),
        key: [settingsConstants.THEME_COLOR_ACCENT],
        defaultValue: '#FF434C',
    },
    {
        title: locale('settings.backgroundColor'),
        key: [settingsConstants.THEME_COLOR_BACKGROUND],
        defaultValue: '#16161B',
    },
    {
        title: locale('settings.textColor'),
        key: [settingsConstants.THEME_COLOR_TEXT],
        defaultValue: '#FFFFFF',
    },
];

export const availableTypesLogo = {
    'image/png': 'png',
    'image/svg+xml': 'svg',
};

export const availableTypesBackground = {
    'image/png': 'png',
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/bmp': 'bmp',
    'image/heif': 'heif',
    'image/heic': 'heic',
};

export const participationTypes = ($locale) => [
    {
        value: settingsConstants.TYPE_ONLINE,
        label: $locale.get('participationType.online'),
    },
    {
        value: settingsConstants.TYPE_OFFLINE,
        label: $locale.get('participationType.offline'),
    },
];

const RESTRICTION_LIST_TYPE = {
    NONE: null,
    WHITELIST: 'whitelist',
    BLACKLIST: 'blacklist',
};

export const viewTypeRestrictionsLists = [
    {
        value: RESTRICTION_LIST_TYPE.NONE,
        label: locale('settings.viewTypeRestriction.none'),
    },
    {
        value: RESTRICTION_LIST_TYPE.WHITELIST,
        label: locale('settings.viewTypeRestriction.whitelist'),
    },
    {
        value: RESTRICTION_LIST_TYPE.BLACKLIST,
        label: locale('settings.viewTypeRestriction.blacklist'),
    },
];

export const SORT_METHOD_TYPE = {
    NONE: null,
    RATING: 'rating',
};
